import { toast } from "react-toastify";

export const copyToClipboard = async (text, successMessage = "کپی شد.") => {
  if (!text) return false;
  try {
    await navigator.clipboard.writeText(String(text));
    toast.success(successMessage);
    return true;
  } catch {
    toast.error("کپی ناموفق بود.");
    return false;
  }
};

export const isPartnerLevel1 = (profile) =>
  String(profile?.partnerLevel || "").toLowerCase() === "level1";

export const isPartnerLevel2 = (profile) =>
  String(profile?.partnerLevel || "").toLowerCase() === "level2";

export const canManageTeam = (profile) =>
  isPartnerLevel1(profile) &&
  Boolean(profile?.canCreateSubPartners) &&
  String(profile?.status || "").toLowerCase() === "active";

/** Level-1 managers see full mobile; level-2 sees masked only. */
export const formatPartnerLeadMobile = (row, isLevel1) => {
  if (!row) return "—";
  if (isLevel1 && row.mobile) return row.mobile;
  return row.maskedMobile || "—";
};
